// Navbar.js
import React from 'react';

const Navbar = () => {
  return (
    <nav className="navbar">
      <h1>My Dashboard</h1>
    </nav>
  );
};

export default Navbar;
